import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  SkeletonBlock,
  SkeletonCircle,
  SkeletonLine,
  SkeletonPill,
} from '../common/Skeleton.web';

export const LibraryDetailSkeleton = memo(function LibraryDetailSkeleton() {
  const { theme, isDark } = useTheme();

  const panelBg = isDark ? theme.surfaceElevated : 'rgba(255,255,255,0.82)';

  return (
    <div
      style={{
        maxWidth: 760,
        marginInline: 'auto',
        width: '100%',
        paddingInline: 16,
        paddingBlock: '20px 32px',
        display: 'grid',
        gap: 20,
      }}
    >
      <section
        style={{
          borderRadius: 28,
          border: `1px solid ${theme.borderSubtle}`,
          backgroundColor: panelBg,
          padding: 20,
          display: 'grid',
          gap: 18,
        }}
      >
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
          <SkeletonCircle size={72} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <SkeletonLine width="62%" height={20} />
            <SkeletonLine width="46%" height={14} />
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <SkeletonPill width={68} />
              <SkeletonPill width={84} />
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <SkeletonPill width={92} height={28} />
          <SkeletonPill width={86} height={28} />
          <SkeletonPill width={78} height={28} />
        </div>
      </section>

      <section
        style={{
          borderRadius: 24,
          border: `1px solid ${theme.borderSubtle}`,
          backgroundColor: panelBg,
          padding: 18,
          display: 'grid',
          gap: 12,
        }}
      >
        <SkeletonLine width="36%" height={16} />
        <SkeletonBlock height={14} />
        <SkeletonBlock height={14} width="92%" />
        <SkeletonBlock height={14} width="78%" />
      </section>

      <section
        style={{
          borderRadius: 24,
          border: `1px solid ${theme.borderSubtle}`,
          backgroundColor: panelBg,
          padding: 18,
          display: 'grid',
          gap: 12,
        }}
      >
        <SkeletonLine width="42%" height={16} />
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {Array.from({ length: 6 }).map((_, idx) => (
            <SkeletonPill
              key={`library-detail-skill-${idx}`}
              width={48 + (idx % 3) * 18}
              height={26}
            />
          ))}
        </div>
      </section>
    </div>
  );
});
